import React, { useState } from "react";
import "./TransferSuccess.css";
import { getFile } from "./constants/Requests";
import { apiGetParamsReplace, endpoints } from "./constants/services.constants";

import { deleteUserAndTokenInStorage } from './helpers/AuthHelper/AuthHelperV2';

import { useNavigate } from "react-router-dom";

const TransferSuccess = ({ shipmentId, shipmentName }) => {

  const navigate = useNavigate();

  const handleCopy = (guid) => {
    navigator.clipboard.writeText(apiGetParamsReplace(endpoints.TRANSFER_FRONTEND_DOWNLOAD, guid));
  };

  return (
    <div className="success-ts-body"

  style={{
    backgroundImage: 'url("/assets/background.jpg")',
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    minHeight: "100vh",
  }}
    >
      <div />
      <div className="success-ts-page">
        <header className="success-ts-header">
          <a href="/">
            <img src="assets/RepublicaTransfer-logo.png"  class="republica-logo" />
          </a>
            <div className="logout-btn" onClick={()=>{deleteUserAndTokenInStorage();window.location.reload()}}>Log out</div>
            <button className="history-btn" type="button" onClick={()=>{navigate("/history")}}>
              Transfer history
            </button>
        </header>
        <main className="success-ts-content">
          <div className="success-ts-card">
            <h1 className="success-ts-title">Your files have been transferred!</h1>            
            <div className="success-ts-name-row">
              {shipmentName}
              <img className="copy-icon" width={15} src="assets/copy-icon.png"  onClick={(e) => { e.stopPropagation(); handleCopy(shipmentId);}}/>
            </div>          
            <div className="success-ts-divider" />
            <div className="success-ts-actions">
              <br/>
              <br/>
              <button className="transfer-rt-btn-primary" style={{width: 200}} onClick={() => window.location.reload()}>
                Send new files
              </button>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default TransferSuccess;